module.exports = __webpack_public_path__ + "static/media/6-antipolicebrutalityflyer.6053c267.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/6-antipolicebrutalityflyer.pdf
// module id = 160
// module chunks = 0